"use client"
import 'aos/dist/aos.css';
import 'aos/dist/aos.js';
import Image from "next/image";
import { useEffect } from 'react';

const EmpoweringSec = () => {
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const AOS = require('aos');
            AOS.init();
        }
    }, []);
    return (
        <section className="bg-[#ffffff] py-7 lg:py-14 md:py-14">
            <div className="container">
                <div data-aos="fade-up" data-aos-duration="1000">
                    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-[20px] lg:gap-[50px] md:gap-[30px]">
                        <div className="overflow-hidden rounded-tr-[30px] rounded-bl-[40px] h-[100%]">
                            <Image
                                width={600}
                                height={600} src="https://exalogic-store.s3.us-east-2.amazonaws.com/exc-academy/about/empowering-futures-fostering-innovators.webp"
                                className="md-m-0 m-auto"
                                alt="empowering-img"
                            />
                        </div>
                        <div className="">
                            <h2 className="text-gray lg:text-[32px] md:text-[24px] text-[20px] font-semibold lg:mb-4 mb-4 leading-tight">Empowering Futures, Fostering Innovators</h2>
                            <p className="text-[#000000] font-normal lg:text-[16px] text-[1rem] mb-4">Through our specialized programs, students delve into real-world challenges, honing their problem-solving skills and cultivating a mindset of innovation.</p>
                            <div className="grid grid-cols-1 lg:grid-cols-1 md:grid-cols-1 gap-1">
                                <div className="mb-3">
                                    <p className="text-[#000000] font-normal lg:text-[14px] text-[14px] mb-0">
                                        <span className="text-[#9014DC] font-bold">Our curriculum</span> emphasizes emerging technologies, equipping students with sought-after skills in today's digital landscape. Through hands-on projects and collaborative learning, our AI course prepares individuals not only for current job roles but also for the evolving demands of future roles.  
                                    </p>
                                </div>
                                <div>
                                    <p className="text-[#000000] font-normal lg:text-[14px] text-[14px] mb-0">
                                        <span className="text-[#9014DC] font-bold">Our Goal</span> is to connect aspiring minds with opportunities in the IT sector. We facilitate networking, mentorship, and career guidance, ensuring that our students don&apos;t just enter the job market but excel in it.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default EmpoweringSec;